export const GlobalCourseId = "global-course";

export const GlobalLessonsIds = [
  "About",
  "AboutProgram",
  "SupportTeam",
  "FAQ",
];
